import { useEffect, useRef } from 'preact/hooks'

export function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function getLowQualityPlaceholder(imageUrl) {
  if (!imageUrl) return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII='
  return `${imageUrl}&width=5`
}

export function ResultImage({
  result,
  children,
  peek = false,
  insideCarousel = false,
  sizes = '50vw',
  widths = IMAGE_WIDTHS
}) {
  const thumbRef = useRef(null)

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [result?.images, result?.image])

  const handleScroll = (e) => {
    const el = e.currentTarget
    const thumb = thumbRef.current
    if (!thumb) return
    const max = el.scrollWidth - el.clientWidth
    const progress = max > 0 ? el.scrollLeft / max : 0
    thumb.style.transform = `translateX(${progress * 100}%)`
  }

  return (
    <div className="relative size-full border-0 aspect-3/4 lg:overflow-hidden">
      {children}
      {result?.images?.length > 2 ? (
        <>
          <div
            onScroll={insideCarousel ? undefined : handleScroll}
            className={`flex ${insideCarousel ? 'overflow-hidden' : 'overflow-x-auto overscroll-x-contain snap-x snap-mandatory'} touch-auto size-full lg:contents [&::-webkit-scrollbar]:hidden [scrollbar-width:none] ${peek ? 'children:animate-result-peek lg:children:animate-none motion-reduce:children:animate-none' : ''}`}
          >
            <img
              key={result.images[0].src}
              className="snap-start shrink-0 lazy w-full h-full object-cover object-bottom transition-all bg-[--section-bg-colour,theme(colors.brand.white)] lg:absolute lg:inset-0 lg:z-10 lg:group-hover/card:opacity-0"
              src={getLowQualityPlaceholder(result.images[0].src)}
              data-src={result.images[0].src}
              data-srcset={generateSrcSet(result.images[0].src, widths)}
              data-sizes={sizes}
              alt={result.images[0].alt || result.title || 'Product image'}
            />
            <img
              key={result.images[1].src}
              className="snap-start shrink-0 lazy w-full h-full object-cover object-bottom bg-[--section-bg-colour,theme(colors.brand.white)] lg:absolute lg:inset-0"
              src={getLowQualityPlaceholder(result.images[1].src)}
              data-src={result.images[1].src}
              data-srcset={generateSrcSet(result.images[1].src, widths)}
              data-sizes={sizes}
              alt={result.images[1].alt || result.title || 'Product image 1'}
            />
          </div>
          <div className={`absolute inset-x-0 bottom-0 h-px overflow-hidden pointer-events-none lg:hidden ${insideCarousel ? 'hidden' : ''}`}>
            <div ref={thumbRef} className="h-full w-1/2 bg-[#101010]" />
          </div>
        </>
      ) : result.image ? (
        <img
          key={result.image}
          className="lazy object-cover object-bottom size-full bg-[--section-bg-colour,theme(colors.brand.white)]"
          src={getLowQualityPlaceholder(result.image)}
          data-src={result.image}
          data-srcset={generateSrcSet(result.image, widths)}
          data-sizes={sizes}
          alt={result.image.alt || result.title || 'Product image'}
        />
      ) : null}
    </div>
  )
}
